import PageContainer from '../components/common/PageContainer'
import { useGetAllProcessAccess } from '../api/process'
import { useParams } from 'react-router-dom'
import ProcessPageHeader from '../components/process/ProcessPageHeader'
import StageAccessCard from '../components/stage/StageAccessCard'
import { useGetNormalAccounts } from '../api/auth'
import { Step } from 'intro.js-react'

export default function ProcessAccesses() {
  const { pid } = useParams<{ pid: string }>()

  const { data: processes } = useGetAllProcessAccess(pid)
  const { data: accounts } = useGetNormalAccounts()

  return (
    <PageContainer introSteps={steps} header={<ProcessPageHeader />}>
      <div className="grid auto-rows-max auto-cols-auto gap-3 sm:grid-cols-1 lg:grid-cols-2">
        {processes
          ?.sort((a, b) => Number(a.id) - Number(b.id))
          ?.map((process) => (
            <StageAccessCard
              id={process.id}
              pid={pid}
              title={process.title}
              accounts={accounts}
              accesses={process.accesses}
              key={process.id}
            />
          ))}
      </div>
    </PageContainer>
  )
}

const steps: Step[] = [
  {
    element: '.access-profile-select',
    intro: 'اگر قصد اعطای دسترسی به کاربری را دارید، ابتدا از این او را انتخاب کنید',
  },
  {
    element: '.grant-access-button',
    intro: 'بعد از انتخاب دسترسی‌های مورد نظر (مشاهده/تغییر) روی این دکمه کلیک کنید.',
  },
  {
    element: '.stage-title',
    intro: 'عنوان مرحله در اینجا آمده است.',
  },
  {
    element: '.access-table',
    intro: 'دسترسی‌ها موجود اینجا لیست می‌شوند.',
  },
  {
    element: '.remove-access-button',
    intro: 'اگر قصد حذف یا تغییر دسترسی را دارید، با این دکمه آن را پاک کنید.',
  },
  {
    element: '#stage-header',
    intro: 'عنوان و توضیحات مرحله را می‌توانید از اینجا ببینید.',
  },
]
